export const hearts = '/hearts/';
